import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { startupDataFetcher } from "../../utilities/data";
import { startupDataKey } from "../../config";

const defaultStartupData = { billboards: [], games: [], lists: [], posts: [], printables: [], standards: [] };
let cachedStartupData = null;
const isGameProxy = window.location.pathname.startsWith("/gameproxy");
try {
  const parsedStartupData = isGameProxy ? [] : JSON.parse(window.localStorage.getItem(startupDataKey));
  if (!Array.isArray(parsedStartupData)) {
    cachedStartupData = parsedStartupData;
    Object.keys(defaultStartupData).forEach((key) => {
      if (!Object.prototype.hasOwnProperty.call(cachedStartupData, key)) {
        cachedStartupData[key] = [];
      }
    });
  }
} catch (e) {}

export const fetchStartupData = createAsyncThunk("data/fetchStartupData", startupDataFetcher);

const dataSlice = createSlice({
  name: "data",
  initialState: {
    loading: !cachedStartupData,
    data: cachedStartupData || defaultStartupData,
    error: null,
  },
  extraReducers(builder) {
    builder
      .addCase(fetchStartupData.fulfilled, (prevState, action) => {
        const state = prevState;
        state.loading = false;
        state.data = action.payload.reduce((allData, dataChunk) => {
          return { ...allData, ...dataChunk };
        }, {});
        if (!isGameProxy) {
          window.localStorage.setItem(startupDataKey, JSON.stringify(state.data));
        }
      })
      .addCase(fetchStartupData.rejected, (prevState, action) => {
        const state = prevState;
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const loadingSelector = (state) => state.data.loading;
export const dataSelector = (state) => state.data.data;
export const errorSelector = (state) => state.data.error;

export default dataSlice.reducer;
